import React, { useEffect, useState } from "react";
import { SectionContent, SectionWrapper } from "./styles";
import { RandomBackgroundSectionProps } from "./types";

/**
 * Componente RandomBackgroundSection
 *
 * Exibe uma seção com um background aleatório e conteúdo renderizado sobre ele.
 *
 * @param {string[]} images - Lista de URLs de imagens para usar como background.
 * @param {React.ReactNode} [children] - Conteúdo renderizado sobre o background.
 * @param {string} [height='400px'] - Altura customizável da seção.
 */
export const RandomBackgroundSection: React.FC<
  RandomBackgroundSectionProps
> = ({ images, children, height = "400px" }) => {
  const [backgroundImage, setBackgroundImage] = useState<string>("");

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * images.length);
    setBackgroundImage(images[randomIndex]);
  }, [images]);

  return (
    <SectionWrapper backgroundImage={backgroundImage} height={height}>
      <SectionContent>{children}</SectionContent>
    </SectionWrapper>
  );
};
